import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Lef-Nav" }
const _hoisted_2 = { class: "App-Lef-Nav-W" }
const _hoisted_3 = { class: "App-Lef-Nav-W-M" }
const _hoisted_4 = { class: "App-Lef-Nav-W-S" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_logo = _resolveComponent("app-logo")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_space, {
          direction: "vertical",
          alignment: "center",
          "w-100": "",
          fill: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_logo, { size: 30 }),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "top")
              ]),
              _createVNode(_component_el_divider),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _renderSlot(_ctx.$slots, "bottom")
                ])
              ])
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1))
          ]),
          _: 3
        })
      ]),
      _createVNode(_component_app_footer, { "txt-center": "" })
    ])
  ]))
}